import { FC } from 'react';

import { DataLink } from 'components/Shared/SharedComponents';
import { setIsAutoSearchCookie, updatePsychicListOptionCookie } from 'src/shared/lib/cookie';
import { RightPsychic } from 'types/objectTypes';

import styles from './styles.module.scss';

import type { IPsychicsList } from '../config/declarations';

const updateCookies = (psychic: RightPsychic) => {
  updatePsychicListOptionCookie('SearchText', psychic.extId);
  setIsAutoSearchCookie(true);
};

export const PsychicsList: FC<IPsychicsList> = ({
  baseLink,
  psychicsList,
  isPsychicListVisible,
}) => {
  if (!psychicsList || psychicsList.length === 0 || !isPsychicListVisible) {
    return null;
  }

  return (
    <ul className={styles.list}>
      {psychicsList.map((psychic) => (
        <li
          key={psychic.extId}
          className={styles.listElement}
        >
          <DataLink
            href={`${baseLink}?search=${psychic.lineName}&extid=${psychic.extId}`}
            className={styles.listElementLink}
            onClick={() => updateCookies(psychic)}
          >
            {psychic.lineName}
          </DataLink>
        </li>
      ))}
    </ul>
  );
};
